import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic  } from 'antd';
import { transfer,transferBnb,balanceOfBNB } from '../../utils/ethers'
import StripedProgressBar from '../../components/progress/Progress'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getIdoInfo, addIdoBnb,addIdoJie} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined,DownOutlined,ExportOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;
const MinttTest = (props) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const ref = useRef()
    const [num,setNum] = useState(0)

    const [max,setMax] = useState(0)
    const [minted,setMinted] =useState(0)
    const [mintedBnb,setMintedBnb] = useState(0)
    const [needBnb,setNeedBnb] = useState("")
    const [receive,setReceive] = useState(0)
    const [per,setPer] = useState(0)
    const [balanceUsdt,setBalanceUsdt]=useState(0)
    const [price,setPrice] = useState(0)
    const [receiveAddress,setReceiveAddress] = useState("")
     const [childs,setChilds] = useState([])
     const [isLock,setIsLock]=useState(false)
     const [isShowMenu,setIsShowMenu] = useState(false);


      const _getTuanInfo = () =>{
             if(props.address.length>0 && props.isLogin){
                 getIdoInfo().then(res=>{
                     if(res.code == 0){
                         setReceiveAddress(res.data.receive)
                         setMax(res.data.total)
                        
                         setMintedBnb(res.data.mintedBnb)
                         setMinted(res.data.minted)
                        setPrice(res.data.price)
                         
                         setPer(res.data.per)
                        if(res.data.list != null){
                            setChilds(res.data.list)
                        }
                       
                         
                     }else{
                         message.error(res.msg)
                     }
                    console.log(res)
                 })
             }
         }


     const _balanceOf = () =>{
        
        if(props.address.length<=0 || !props.isLogin) return false
      
        balanceOfBNB(props.address).then(res=>{
            
            setBalanceUsdt(res)
        })

    }

    const handleChange = (value) => {
        if(price == 0||price.length==0){
            return
        }
        
        
        
         if(value>5){
            value = 5
         }
         
          setNeedBnb(value);
          let _receive = value*price
          _receive = _receive.toFixed(2);
          setReceive(_receive)
         
        
    }

    const _isStartIdo = () =>{
        //  message.error(t('g.暂未开始'))
        //         return
        // let now = Date.now() /1000
        // if(parseFloat(now) < 1785918660){
        //       message.error(t('g.暂未开始'))
        //         return
        // }
        // console.log(222)
            if(needBnb<0){
                return
            }
            
            if(props.address.length === 0){
                message.error(t('g.请先连接钱包'))
                return false
            }
            if(props.isLogin === false){
                message.error(t('g.请先绑定邀请地址'))
                return false
            }
            if(receiveAddress.length==0){
                  message.error(t('mint.钱包地址获取错误'))
                return false
            }
            if(needBnb.length==0){
                 message.error(t('mint.请重新输入BNB数量'))
                 return false
            }
            if(parseFloat(needBnb)<0.000001 || parseFloat(needBnb)>5){
                message.error(t('mint.输入范围')+"：0.1-5BNB")
                return false
           }
           if(isLock){
                return false
            }
            setIsLock(true)
          console.log(needBnb)
            transferBnb(props.address,receiveAddress,needBnb).then(
                res2=>{
                    // message.success(res2)
                   addIdoBnb({
                        address:props.address,
                        mints:needBnb.toString(),
                        hex:res2.hash,
                        
                    }).then(
                        res=>{
                            // audioRef.current.play()
                            // setIsOpen(false)
                            message.success(res.msg)
                         
                            setNum(num+1);
                            setIsLock(false)
                        })
                           
                        
                },err2=>{
                    setIsLock(false)
                    message.error(err2)
                }
            )
        }


   const [countdown, setCountdown] = useState({
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
        });

         const openNewPagex = () => {
        window.open('https://x.com/spx_meme', '_blank');
      };

      const openNewPaget = () => {
        window.open('https://t.me/SpaceXMemeOfficial', '_blank');
      };

      const openNewPagey = () => {
        window.open('https://youtube.com/@spacexmeme-666', '_blank');
      };

      const open = (e) => {
        window.open('https://bscscan.com/tx/'+e, '_blank');
      };
    
        useEffect(() => {
            window.scrollTo(0, 0)
            const targetTime = new Date("2026-08-05 16:31:00").getTime();

            const timer = setInterval(() => {

                const now = Date.now();
                const diff = targetTime - now;

                if (diff <= 0) {
                clearInterval(timer);

                setCountdown({
                    days: "00",
                    hours: "00",
                    minutes: "00",
                    seconds: "00",
                });

                return;
                }

                const days = Math.floor(
                diff / (1000 * 60 * 60 * 24)
                );

                const hours = Math.floor(
                (diff % (1000 * 60 * 60 * 24)) /
                (1000 * 60 * 60)
                );

                const minutes = Math.floor(
                (diff % (1000 * 60 * 60)) /
                (1000 * 60)
                );

                const seconds = Math.floor(
                (diff % (1000 * 60)) /
                1000
                );

                setCountdown({
                days: String(days).padStart(2, "0"),
                hours: String(hours).padStart(2, "0"),
                minutes: String(minutes).padStart(2, "0"),
                seconds: String(seconds).padStart(2, "0"),
                });

            }, 1000);
  _getTuanInfo()
            _balanceOf()
          

            return () => clearInterval(timer);

            }, 
            // eslint-disable-next-line
            [props.isLogin,num]);

    // useEffect(() => {
    //     // window.scrollTo(0, 0)
         


    // }, 
    // // eslint-disable-next-line
    // [props.isLogin,num]);

    // const clearTimer = () =>{
    //     clearInterval(ref.current)
    // }
    

    return (
        <>
         <CSSTransition
                    in={isShowMenu}
                    unmountOnExit={true}
                    classNames='lan'
                    timeout={1000}
                    appear
                    onEnter={(e) => console.log('开始进入动画')}
                    onEntering={(e) => console.log('执行进入动画')}
                    onEntered={(e) => console.log('进入动画结束')}
                    onExit={(e) => console.log('开始离开动画')}
                    onExiting={(e) => console.log('正在离开动画')}
                    onExited={(e) => console.log('离开动画结束')}>
                    <div
                    className="
                        fixed inset-0 z-50
                        flex items-center justify-center
                        bg-black/30
                        backdrop-blur-[14px]
                        backdrop-saturate-150
                        px-4
                    "
                    >
                    <div
                        className="
                        relative
                        w-full max-w-[390px]
                        min-h-[520px]
                        px-5 py-6
                        overflow-hidden

                        bg-black/80

                        border-0 border-[#4A5560]

                        shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

                        [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
                        "
                    >
                        {/* Close */}
                        <button
                        onClick={()=>setIsShowMenu(false)}
                        className="
                            absolute right-4 top-4 z-50
                            w-6 h-6
                            flex items-center justify-center

                            text-text1
                            text-[14px]
                            leading-none

                            border border-[#3A444E]
                            bg-[#070D12]/95

                            [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

                            transition-all duration-200

                            hover:text-text1
                            hover:border-[#6B7680]
                            hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
                        "
                        >
                        ×
                        </button>

                        {/* 外层细线 */}
                        <div
                        className="
                            absolute inset-[6px]
                            pointer-events-none
                            border border-[#171c20]

                            [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
                        "
                        />

                        

                        

                        {/* 左上角 */}
                        <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
                        

                        {/* 右上角 */}
                        <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
                        

                        {/* 左下角 */}
                        <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
                        

                        {/* 右下角 */}
                        <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
                    

                    

                        {/* 内部暗色纹理线 */}
                        <div
                        className="
                            absolute inset-0
                            opacity-25
                            pointer-events-none
                            bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
                        "
                        />

                        {/* 内容区域 */}
                        <div className="relative z-10">
                        {/* 这里放你的弹窗内容 */}
                            <div className=' w-full py-4 mt-2 flex flex-col'>
                    
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-3/12'>{t('mint.时间')}</span>
                        <span className='w-2/12'>{t('mint.状态')}</span>
                        <span className='w-1/12'>BNB</span>
                        <span className='w-3/12 text-center'>SPACEX</span>
                        <span className='w-3/12'>{t('mint.凭证')}</span>
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    
                    {
                            childs.length>0?
                            childs.map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                            <span className='w-3/12'>{item.add_time}</span>
                                            {
                                                item.state==0?(
                                                    <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                                ):(
                                                    <span className='w-2/12 text-orange-500'>{t('air.确认中')}</span>
                                                )
                                            }
                                            
                                            <span className='w-1/12'>
                                                <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={item.bnb}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} />
                                            </span>
                                            <span className='w-3/12 text-center'>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.token}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                            </span>
                                            <div onClick={()=>open(item.hex)} className='w-3/12 flex flex-row items-center justify-start'>
                                                <span className=' text-[#24C4E8]'>{item.add_hex}</span>
                                                <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                            </div>
                                        </div>
                                        <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }
                    


                
                </div>
                        {/*  */}
                        </div>
                    </div>
                    </div>
                    </CSSTransition>
            <Head/>
            <div className=' invitebg  w-full lg:w-1/3 md:w-1/3 sm:1/2  px-0 pt-12 text-white flex flex-col z-10'>
                {/*  */}
                <div className='w-full lg:w-1/3 px-0   min-h-[203px]  flex flex-row  '>
                    <div className=' w-full lg:w-1/3 md:w-1/3 sm:1/2 min-h-[203px]  absolute '>
                        {/* spacex火箭特效代码 */}
              
<div className="absolute inset-0 overflow-hidden pointer-events-none">
  {/* 星光粒子 */}
  <div className="absolute inset-0 rocket-stars" />

  {/* 流星 */}
  <div className="meteor meteor-1" />
  <div className="meteor meteor-2" />
  <div className="meteor meteor-3" />
  <div className="meteor meteor-4" />

  {/* 火箭 */}
  <div className="absolute right-[0px] top-[32px] z-20 w-[260px] animate-rocket-float">
    <img
      src={require("../../assets/ipo/rock.png")}
      alt="rocket"
      className="relative z-20 w-full drop-shadow-[0_0_18px_rgba(255,122,0,.55)]"
    />

    {/* 覆盖火箭素材尾部原火焰 */}
    <div className="rocket-tail-cover" />

    {/* 喷火动态光效 */}
    <div className="rocket-flame flame-a" />
    <div className="rocket-flame flame-b" />
    <div className="rocket-flame flame-c" />
    <div className="rocket-glow" />
  </div>
</div>
                        {/*  */}
                    </div>
                    <div className='w-[53%] pl-4 flex flex-col z-40'>
                        <img className='mt-5  '  src={require('../../assets/ipo/ss.png')} style={{"width":"158px"}}></img>
                        <span className='mt-[5px] text-text1 text-[10px]' >{t('mint.全球首个星舰粉丝群发射的AI智能体代币')}</span>
                        <span className='mt-[8px] text-white text-[10px]' >{t('mint.星舰属于每一个仰望星空的人')}</span>
                        <span className='mt-[5px] text-gray-400 text-[9px]' >{t('mint.$SpaceX是Starlink在加密世界的旗舰资产，由星舰基金会直接运营，与SpaceX共享星辰大海的愿景')}</span>
                        <div className='mt-3 timebg w-[171px] h-[66px] flex flex-col items-center '>
                            <span className='mt-1 text-[10px] text-text1'>{t('mint.倒计时')}</span>
                            <div className='flex flex-row justify-between items-center'>
                                <div className='timebg1 w-9 h-10 flex flex-col justify-center items-center'>
                                    <span className=' text-text1 text-sm'>{countdown.days}</span>
                                    <span className=' text-[7px]'>{t('mint.天')}</span>
                                </div>
                                <img className=' '  src={require('../../assets/ipo/timeline.png')} style={{"width":"2px"}}></img>
                                <div className='timebg1 w-9 h-10 flex flex-col justify-center items-center'>
                                    <span className=' text-text1 text-sm'>{countdown.hours}</span>
                                    <span className=' text-[7px]'>{t('mint.时')}</span>
                                </div>
                                <img className=' '  src={require('../../assets/ipo/timeline.png')} style={{"width":"2px"}}></img>
                                <div className='timebg1 w-9 h-10 flex flex-col justify-center items-center'>
                                    <span className=' text-text1 text-sm'>{countdown.minutes}</span>
                                    <span className=' text-[7px]'>{t('mint.分')}</span>
                                </div>
                                <img className=' '  src={require('../../assets/ipo/timeline.png')} style={{"width":"2px"}}></img>
                                <div className='timebg1 w-9 h-10 flex flex-col justify-center items-center'>
                                    <span className=' text-text1 text-sm'>{countdown.seconds}</span>
                                    <span className=' text-[7px]'>{t('mint.秒')}</span>
                                </div>
                            </div>
                        </div>
                        

                    </div>
                    
                </div>
                {/*  */}
                <div className='mx-4  mt-3 pl-4 pr-3  probg1 h-[100px]  flex flex-col '>
                    <div className='w-full h-6 mt-4 flex flex-row justify-start items-center'>
                        <div className=' flex flex-col w-7/12'>
                            <span className='text-text1 text-[9px]'>{t('mint.铸造进展')}</span>
                            <span className=' text-[10px]'><CountUp start={0} end={minted} duration="1" decimals={2} /> SPACEX</span>
                        </div>
                        <div className='ml-3 flex flex-col w-5/12 '>
                            <span  className='text-text1 text-[9px] text-right mr-2'>{t('mint.完成指标')}</span>
                            <span className=' text-[10px] text-gray-200 text-right mr-2'><CountUp start={0} end={mintedBnb} duration="1" decimals={2} />/<CountUp start={0} end={max} duration="1" decimals={2} /> BNB</span>
                        </div>
                        {/* <div className='ml-2 flex flex-col w-3/12 pl-2'>
                            <span  className='text-text1 text-[10px]'>{t('mint.硬顶')}</span>
                            <span className=' text-[10px] text-gray-200'><CountUp start={0} end={max} duration="1" decimals={2} /> BNB</span>
                        </div> */}
                    </div>
                    <div className='mt-2  flex flex-row justify-start items-end'>
                        <div className='w-full mr-2'>
                            <StripedProgressBar value={per} />
                        </div>
                         {/* <span className='text-gray-100 text-base'>
                            <CountUp start={0} end={per} duration="1" decimals={2} />%  
                        </span> */}
                    </div>
                    <div className='mt-1  flex flex-row justify-between items-center'>
                        <span className='text-gray-400 text-[9px]'>{t('mint.铸造价格')}≈‌$0.000195 
                        </span>
                        <span className='text-gray-100 text-base'>
                            <CountUp start={0} end={per} duration="1" decimals={2} />%  
                        </span>
                    </div>
                </div>

                {/*  */}
                <div className=' mx-4 mt-3 pl-4 pr-4  SWAPbg1 h-[210px]  flex flex-col items-center '>
                    <span className='mt-3 text-text1 text-[11px] leading-[11px]'>{t('mint.铸造')} $SPACEX</span>
                    <div className='mt-1 flex flex-row justify-center items-center text-[8px] leading-[8px]'>
                        <div className='w-1 h-1 mr-1 rounded-full bg-green-500'></div>
                        <span className=' text-green-500'>PRESALE LIVE</span>
                    </div>
                    <div className='mt-2 w-full flex flex-col items-center relative'>
                        <img className='-bottom-5  absolute z-[40]'  src={require('../../assets/ipo/arr.png')} style={{"width":"30px"}}></img>
                        <div className="w-full min-h-[50px]
                                relative inline-flex flex-col h-4  justify-start 
                                px-3 py-2 text-white text-[10px]  tracking-wider
                                [--cut:4px] [--border:1px]
                                before:absolute before:inset-0 before:bg-gray-800
                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                            ">
                            <div className='w-full z-10 flex flex-row justify-between items-center'>
                                <span className='text-[10px] leading-[10px] text-text1'>{t('mint.支付')}</span>
                                <span className='text-[9px] leading-[9px] text-gray-400'>{t('mint.钱包余额')}: <NumberFormat
                                thousandsGroupStyle="thousand"
                                value={balanceUsdt}
                                prefix=""
                                decimalSeparator="."
                                displayType="text"
                                type="text"
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                allowNegative={false}
                                decimalScale={2} /> BNB</span>
                            </div>
                           <div className='mt-1 w-full z-10 flex flex-row justify-between items-center'>
                                <div className="w-20
                                    relative inline-flex h-5 items-center justify-start
                                    px-2 py-3 text-white text-[10px]  tracking-wider
                                    [--cut:3px] [--border:1px]
                                    before:absolute before:inset-0 before:bg-gray-800
                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                ">
                                     <img className='  z-10' alt='logo' src={require('../../assets/ipo/bnblogo.png')} style={{"width":"15px"}}></img>
                                     <span className="ml-1 z-10 text-[12px] text-[#F9B514]">BNB</span>
                                    {/* <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  /></span> */}
                                </div>
                                <div className=' w-1/2    flex flex-row justify-center items-center  '>
                                            <input  type="number"  onInput={(e)=>handleChange(e.target.value)} value={needBnb} placeholder={t('mint.输入最低')+" 0.1BNB"}   className='placeholder:text-[10px] w-full text-base text-white input1 text-right '  />
                                    </div>
                                
                            </div>
                           
                        
                        </div>
                    </div>

                    <div className='mt-2 w-full flex flex-col items-center relative'>
                        <div className="w-full min-h-[50px]
                                relative inline-flex flex-col h-4  justify-start 
                                px-3 py-2 text-white text-[10px]  tracking-wider
                                [--cut:4px] [--border:1px]
                                before:absolute before:inset-0 before:bg-gray-800
                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                            ">
                            <div className='w-full z-10 flex flex-row justify-between items-center'>
                                <span className='text-[10px] leading-[10px] text-text1'>{t('mint.接收')}</span>
                                {/* <span className='text-[9px] leading-[9px] text-gray-400'>BALANCE: 0.00 SPACEX</span> */}
                            </div>
                           <div className='mt-1 w-full z-10 flex flex-row justify-between items-center'>
                                <div className="w-[100px]
                                    relative inline-flex h-5 items-center justify-start
                                    px-2 py-3 text-white text-[10px]  tracking-wider
                                    [--cut:3px] [--border:1px]
                                    before:absolute before:inset-0 before:bg-gray-800
                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                ">
                                     <img className='  z-10' alt='logo' src={require('../../assets/ipo/logo1.png')} style={{"width":"17px"}}></img>
                                     <span className="ml-1 z-10 text-[12px] text-[#F9B514]">SPACEX</span>
                                    {/* <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  /></span> */}
                                </div>
                                <div className=' w-1/2    flex flex-row justify-center items-center  '>
                                            <input  type="number" disabled   value={receive} placeholder=''  className=' w-full text-base text-white input1 text-right '  />
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-center w-full mt-3">
                        <button onClick={_isStartIdo} className="sci-glow-btn"> <span>测试{t('mint.立刻铸造')}</span></button>
                    </div>
                    {/* <div className=' mt-1 w-full flex flex-row justify-center items-center'>
                        <img className='  z-10' alt='logo' src={require('../../assets/ipo/lock.png')} style={{"width":"8px"}}></img>
                        <span className="ml-1 z-10 text-[10px] text-gray-600">Secure Transaction</span>
                    </div> */}
                    
                </div>
                {/*  */}
                <div className='holdbg mx-4 mt-2  h-[60px] px-3 flex flex-row justify-between items-center'>
                    <div className="w-16 flex flex-row justify-start items-center">
                        <img className=' mr-1' alt='' src={require('../../assets/ipo/hold1.png')} style={{"width":"15px"}}></img>
                        <div className='flex flex-col '>
                            <span className='text-text1 text-[7px]'>{t('mint.发行')}</span>
                            <span className='text-[10px]'>100,000M</span>
                        </div>
                    </div>
                    <div className=' h-5 w-px bg-gray-800 mx-2'></div>
                    <div className="w-14 flex flex-row justify-start items-center">
                        <img className=' mr-1' alt='' src={require('../../assets/ipo/hold2.png')} style={{"width":"15px"}}></img>
                        <div className='flex flex-col '>
                            <span className='text-text1 text-[7px]'>{t('mint.持有人')}</span>
                            <span className='text-[10px]'>∞</span>
                        </div>
                    </div>
                    <div className=' h-5 w-px bg-gray-800 mx-2'></div>
                    <div className="w-20 flex flex-row justify-start items-center">
                        <img className=' mr-1' alt='' src={require('../../assets/ipo/hold3.png')} style={{"width":"15px"}}></img>
                        <div className='flex flex-col '>
                            <span className='text-text1 text-[7px]'>{t('mint.现价')}</span>
                            <span className='text-[10px]'>$0.000195</span>
                        </div>
                    </div>
                    <div className=' h-5 w-px bg-gray-800 mx-2'></div>
                    <div className="w-14 flex flex-row justify-start items-center">
                        <img className=' mr-1' alt='' src={require('../../assets/ipo/hold4.png')} style={{"width":"15px"}}></img>
                        <div className='flex flex-col '>
                            <span className='text-text1 text-[7px]'>{t('mint.预售')}</span>
                            <span className='text-[10px]'>10%</span>
                        </div>
                    </div>
                </div>

                {/*  */}
                <div className='recordbg mx-4 h-36 px-4 py-4 mt-2 flex flex-col'>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className='text-text1 text-[9px]'>{t('mint.参与记录')}</span>
                        <span onClick={()=>setIsShowMenu(true)} className='text-text1 text-[10px]'>{t('mint.全部')}</span>
                    </div>
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-3/12'>{t('mint.时间')}</span>
                        <span className='w-2/12'>{t('mint.状态')}</span>
                        <span className='w-1/12'>BNB</span>
                        <span className='w-3/12 text-center'>SPACEX</span>
                        <span className='w-3/12'>{t('mint.凭证')}</span>
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    
                    {
                            childs.length>0?
                            childs.slice(0,3).map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                             <span className='w-3/12'>{item.add_time}</span>
                                            {
                                                item.state==0?(
                                                    <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                                ):(
                                                    <span className='w-2/12 text-orange-500'>{t('air.确认中')}</span>
                                                )
                                            }
                                            
                                            <span className='w-1/12'>
                                                <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={item.bnb}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} />
                                            </span>
                                            <span className='w-3/12 text-center'>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.token}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                            </span>
                                            <div onClick={()=>open(item.hex)} className='w-3/12 flex flex-row items-center justify-start'>
                                                <span className=' text-[#24C4E8]'>{item.add_hex}</span>
                                                <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                            </div>
                                        </div>
                                        <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }
                    


                
                </div>

                {/*  */}
                <div className='mt-2 mx-4 h-24 xbg flex flex-col items-center justify-start'>
                    <span className=' text-text1 text-xs mt-3'>SPACEX {t('mint.加入使命')}</span>
                    <span className=' text-gray-400 text-[10px] mt-1'>{t('mint.保持联系，成为我们旅程的一部分')}</span>
                    <div className='mt-2 flex flex-row justify-between items-center'>
                        <div onClick={openNewPagex} className="w-[80px] ml-1
                                    relative inline-flex h-6 items-center justify-start
                                    px-2 py-3 text-white text-[10px]  tracking-wider
                                    [--cut:4px] [--border:1px]
                                    before:absolute before:inset-0 before:bg-[#D17501]
                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                ">
                                     <img className='  z-10' alt='logo' src={require('../../assets/ipo/tt.png')} style={{"width":"17px"}}></img>
                                     <span className="ml-1 z-10 text-[7px] text-gray-200">FOLLOW X</span>
                                    
                                </div>

                                <div onClick={openNewPaget} className="w-[80px] ml-2
                                    relative inline-flex h-6 items-center justify-start
                                    px-2 py-3 text-white text-[10px]  tracking-wider
                                    [--cut:4px] [--border:1px]
                                    before:absolute before:inset-0 before:bg-[#D17501]
                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                ">
                                     <img className='  z-10' alt='logo' src={require('../../assets/ipo/tel.png')} style={{"width":"17px"}}></img>
                                     <span className="ml-1 z-10 text-[7px] text-gray-200">TELEGRAM</span>
                                    
                                </div>

                                <div onClick={openNewPagey} className="w-[80px] ml-2
                                    relative inline-flex h-6 items-center justify-start
                                    px-2 py-3 text-white text-[10px]  tracking-wider
                                    [--cut:4px] [--border:1px]
                                    before:absolute before:inset-0 before:bg-[#D17501]
                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                ">
                                     <img className='  z-10' alt='logo' src={require('../../assets/ipo/youtube.png')} style={{"width":"17px"}}></img>
                                     <span className="ml-1 z-10 text-[7px] text-gray-200">YOUTUBE</span>
                                    
                                </div>
                    </div>
                </div>
                {/*  */}
                <div className=' h-[100px]'></div>
            </div>
           
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(MinttTest);
